import { Table } from "@mantine/core";
import type { ReactNode } from "react";

interface ParentProps {
  children?: ReactNode;
}

/**
 * MarkdocTable renders a table and its row/cell relatives through the Mantine
 * `Table` family, with borders and striping for readability.
 */
export const MarkdocTable = ({ children }: ParentProps) => (
  <Table.ScrollContainer minWidth={320} my="md">
    <Table striped withColumnBorders withTableBorder>
      {children}
    </Table>
  </Table.ScrollContainer>
);

export const TableThead = ({ children }: ParentProps) => <Table.Thead>{children}</Table.Thead>;
export const TableTbody = ({ children }: ParentProps) => <Table.Tbody>{children}</Table.Tbody>;
export const TableTr = ({ children }: ParentProps) => <Table.Tr>{children}</Table.Tr>;
export const TableTh = ({ children }: ParentProps) => <Table.Th>{children}</Table.Th>;
export const TableTd = ({ children }: ParentProps) => <Table.Td>{children}</Table.Td>;
